import React from "react";
import { ChartData, NameValuePair } from "../Shared/ProfileData/ChartData";
import { ChartDisplay, ChartDisplayProps } from "./ChartDisplay";
import { GetClasses } from "./CSSPicker";
import { ItemWeeklyActivity } from "../Shared/Map/MapData";



export type ActivityPanelProps = {
    engagement: ItemWeeklyActivity,
    width: number;
    height: number;
    regionName: string;
    idPrefix: string;
}

const convertToConsumptionTime = (value: number): string => {
    const hour = Math.round(value / 60)
    if (hour > 9) {
        var hourS = hour + '';
        if (hourS.length > 3)
            hourS = hourS.slice(0, hourS.length - 3) + ',' + hourS.slice(hourS.length - 3);
        return hourS + 'h';

    }
    else {
        const min = Math.round(value % 60);
        //const padHour = hour < 10 ? '0' : '';
        const padMin = min < 10 ? '0' : '';
        return hour + "h " + padMin + min + 'm';
    }
}

const ToCommaString = (n: number): string => {
    const ns = '' + n;
    if (ns.length < 4) return ns;
    else {
        var ret = ns.slice(ns.length - 3);
        for (let i = ns.length - 3; i > 0; i = i - 3) {
            const first = (i - 3) >= 0 ? i - 3 : 0;
            ret = ns.slice(first, i) + ',' + ret;

        }
        return ret;
    }
}

type ActivityNumberDisplayProps = {
    name: string,
    value: string,
    widthName: number,
    widthValue: number

}

const ActivityNumberDisplay = ({ name, value, widthName, widthValue }: ActivityNumberDisplayProps): JSX.Element => {

    return (
        <div style={{ display: 'flex' }}>
            <div style={{ display: 'flex', width: widthName + "px" }}>
                <span style={{ fontFamily: "Roboto", fontSize: "18px", color: "white", fontWeight: 700, textAlign: 'left' }}>{name} </span>
            </div>
            <div style={{ width: widthValue + "px", display: 'flex', flexDirection: 'row-reverse' }}>
                <span style={{ fontFamily: "Roboto", fontSize: "18px", color: "#d1d130", fontWeight: 700, textAlign: 'left', marginLeft: "4px" }}> {value}</span>
            </div>
        </div>);
}


export const ActivityPanel = ({ engagement, width, height, idPrefix, regionName }: ActivityPanelProps): React.JSX.Element => {

    const hourly = engagement.hourly.flat();
    const hourMilliseconds = 60 * 60 * 1000
    const dayMilliseconds = 24 * hourMilliseconds;
    const start = new Date();
    start.setTime(Date.now() - 8 * dayMilliseconds);
    const end = new Date();
    end.setTime(Date.now() - dayMilliseconds);

    const nvps = new Array<NameValuePair>();
    for (let i = 0; i < hourly.length; i++) {
        const t = new Date();
        t.setTime(start.getTime() + i * hourMilliseconds);
        const label = t.toDateString() + " " + t.toTimeString();
        nvps.push({ name: label, value: hourly[i] });
    }

    const chartData: ChartData = {
        title: "Your Activity Last Week",
        chartType: "line",
        data: nvps
    }

    const chartProps: ChartDisplayProps = {
        chartData: chartData,
        x: 0,
        y: 0,
        width: width,
        height: height - 240,
        options: {
            showAxis: false,
            barCSS: ['LowFill5'],
            barHighlightCSS: ['HighFill2'],
            axisColor: 'black',
            bottomLabelSpace: 0,
            yCalculator: 'zero',
            yCalcParameter: 0,
            valuePostfix: ' Fans',
            textHeight: 14,
            xmin: start.getTime(),
            xmax: end.getTime(),
            isDate: true,
            idPrefix: idPrefix + "ActivityChart",
            barWidth: 1.0,
        }

    }

    const activitiesToShow = engagement.activity.consumed.slice(0,5);


    return (
        <div style={{
            display: "flex",
            flexDirection: "column",
            minWidth: width + "px",
            maxWidth: width + "px",
            width: width + "px",
            minHeight: height + "px",
            maxHeight: height + "px",
            height: height + "px",
            backgroundColor: "black",
        }}>
            <span style={{ fontFamily: "Roboto", fontSize: "25px", color: "white", fontWeight: 700, marginTop: "10px" }}>Activity this week in {regionName}</span>
            <div style={{
                display: "flex",
                flexDirection: "row",
                minWidth: width + "px",
                maxWidth: width + "px",
                width: width + "px",
                marginTop: "10px"
            }}>
                <div style={{
                    display: "flex",
                    flexDirection: "column",
                    minWidth: (0.5 * width-7) + "px",
                    maxWidth: (0.5 * width-7) + "px",
                    width: (0.5 * width-7) + "px",
                    overflow : 'clip',
                    borderRight : "1px solid white"
                }}>
                    <ActivityNumberDisplay name="Fans Visited: " value={ToCommaString(engagement.activity.uniques)} widthName={0.35 * width} widthValue={0.125 * width}/>
                    <ActivityNumberDisplay name="Reactions: " value={ToCommaString(engagement.activity.reactions)} widthName={0.35 * width} widthValue={0.125 * width}/>
                    <ActivityNumberDisplay name="Comments: " value={ToCommaString(engagement.activity.comments)} widthName={0.35 * width} widthValue={0.125 * width}/>
                    <ActivityNumberDisplay name="Quiz Answers: " value={ToCommaString(engagement.activity.quiz)} widthName={0.35 * width} widthValue={0.125 * width}/>
                    <ActivityNumberDisplay name="Fan Creative Shared: " value={ToCommaString(engagement.activity.creative)} widthName={0.35 * width} widthValue={0.125 * width}/>
                    <ActivityNumberDisplay name="Largest Audience: " value={ToCommaString(engagement.activity.audience)} widthName={0.35 * width} widthValue={0.125 * width}/>
                    
                </div>
                <div style={{
                    display: "flex",
                    flexDirection: "column",
                    minWidth: (0.5 * width) + "px",
                    maxWidth: (0.5 * width) + "px",
                    width: (0.5 * width) + "px",
                    marginLeft : "10px"
                }}>
                    <ActivityNumberDisplay name="Content Consumed: " value={convertToConsumptionTime(engagement.activity.consumedTotal)} widthName={0.35 * width} widthValue={0.125 * width}/>

                    {
                        activitiesToShow.map((nvp : NameValuePair, index : number) => {
                            return <ActivityNumberDisplay name={nvp.name + " Content:"} key={'ActivityPanelConsumedContent' + index} value={convertToConsumptionTime(nvp.value)} widthName={0.35 * width} widthValue={0.125 * width}/>
                        })
                    }
                </div>
            </div>

            <svg id={idPrefix + "SVG"} width={width} height={height - 175}>
                <ChartDisplay {...chartProps} />
            </svg>
        </div>
    );

} 